<template>
  <div>
  <div class="container seg-content general user">
    <section class="home-list">
      <div class="actions" style="grid-column: span 2">
        <a class="new-button" href="" v-on:click.prevent="selectNew">Add New User</a><br />
<!--       <a class="new-button" href="" v-on:click.prevent="doImport">Import subscribers</a> -->
      </div>
      
      <user-import v-if="importing" />
      <item-list entity="User" v-else-if="selectedItem===null" v-on:select="selectedItem=$event" v-on:remove="removeItem($event)" />
      <user-edit entity="User" v-else :item="selectedItem" v-on:save="selectedItem=null" v-on:update="doUpdate()" />
<!--       <user-package v-if="!importing && selectedItem!==null && selectedItem.id" :item="selectedItem" v-on:save="selectedItem=null" v-on:update="doUpdate()" /> -->
    </section>

    
    

    
  </div>
  </div>
</template>
<script>
export default {
  data: ()=>({
    menuOpen: false,
    selectedItem: null,
    importing: false,
  }),
  methods: {
    toggleMenu() {
      this.menuOpen=!this.menuOpen;
      if (!this.menuOpen)
        this.$refs.mobileMenu.menuSubOpen=null;
    },
    action($event) {
      var actionName="action"+($event.name[0].toUpperCase())+($event.name.substring(1));
      
      this[actionName] && this[actionName]($event);
    },
    async removeItem(item) {
      if (item.id)
        await api.delete("User", item.id);
      appNotifications.show("User deleted", "");
    },
    selectNew() {
      this.selectedItem={
        id: null, active: "Yes", firstname: "", lastname: "",
        media: null, username: "", email: "", password: null, groups: [],
        emailprefs: [], pubname: "", title: "", gender : "", location :"",
        address: null, country: null, phone: null, agreed: true, pubdesc: "",
        experience :"1", birthday:"", frequency: "Daily", website: null,
        linkFacebook: "", linkInstagram: "", linkTwitter: "",
        linkLinkedin: "", languages: "", teacherLevel:"", teacherName: null,
        teacherStudio: null, teacherDate: null, studioName: "", studioWeb: "",
        studioAbout:"", studioLocation: "", studioEmail: "",
        studioPhoto1: null, studioPhoto2: null, studioPhoto3: null,
        studioPhoto4: null, studioLogo: null, linkedCode: null,
        showAge: false, teacher: false, owner: false,
        pace: "", level: "", speciality :"", aparatus :"", prop: "", part:"",
        activePayment:null, lastPayment:null, package: null
      };
    },
    doImport() {
      this.importing=true;
      
    },
    async doUpdate() {
      if (this.selectedItem && this.selectedItem.id)
        this.selectedItem=(await api.get("User", this.selectedItem.id)).item;
    },
  },
}
</script>
